import { Card, Divider, List, ListItem, Popper } from '@material-ui/core';
import CaretIcon from '@material-ui/icons/ExpandMore';
import HelpIcon from '@material-ui/icons/HelpOutline';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import BookOpenIconCustom from './CustomIcons/BookOpenIconCustom.jsx';
import MessageAlertIconCustom from './CustomIcons/MessageAlertIconCustom.jsx';


@connect((state) => ({ user: state.user.data }))
class HelpMenuDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      anchorEl: null,
    };
  }

  componentWillUnmount() {
    if (this.closeTimer) clearTimeout(this.closeTimer);
  }

  // Il Popper e' renderizzato in portal (fuori dal contenitore con zoom), quindi
  // non e' piu' un discendente del wrapper: spostando il mouse sul menu scatta
  // onMouseLeave. Chiudiamo con un piccolo ritardo, annullato se il mouse entra
  // nel menu, cosi' l'hover tra trigger e menu resta fluido.
  scheduleClose() {
    if (this.closeTimer) clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => this.setState({ isOpen: false, anchorEl: null }), 120);
  }

  cancelClose() {
    if (this.closeTimer) clearTimeout(this.closeTimer);
  }

  render() {
    const { isOpen, anchorEl} = this.state;
    const { onOpenOnlineGuide, onOpenSupportTicket } = this.props;
    
    return (
      <div
        onMouseEnter={(e) => { this.cancelClose(); this.setState({ anchorEl: e.currentTarget, isOpen: true }); }}
        onMouseLeave={() => this.scheduleClose()}
      >
        <div
          aria-controls="language-menu"
          aria-haspopup="true"
          onClick={(e) => this.setState({ anchorEl: e.currentTarget, isOpen: true })}
        >
          <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', marginTop: 4, marginRight: 10, marginLeft: 20 }}>
            <HelpIcon style={{ marginRight: 0, marginBottom: 0, fontSize: 28, color: 'white'}} />
            <CaretIcon style={{ marginBottom: -2, fontSize: 20, color: 'white', marginLeft: 10 }} />
          </div>
        </div>
        <Popper
          className="r-header-popper"
          open={isOpen}
          anchorEl={anchorEl}
          onMouseEnter={() => this.cancelClose()}
          onMouseLeave={() => this.scheduleClose()}
          disablePortal={false}
          placement='bottom-end'
          modifiers={{
            flip: {
              enabled: true,
            },
            preventOverflow: {
              enabled: true,
              boundariesElement: 'viewport',
            }
          }}
          style={{ zIndex: 9999, minWidth: 350, paddingTop: 10 }}
        >
          <Card style={{ backgroundColor: 'white' }}>
            <List component="nav" aria-label="main mailbox folders">
              <ListItem key='flag-header' header style={{ backgroundColor: '#f0f0f0', marginTop: -10, height: 40 }}>
                <h5 style={{ margin: 0 }}><Entity entity="support" /></h5>
                </ListItem>
              <Divider />
              <ListItem
                key="help-0"
                button
                onClick={() => {
                  this.setState({ isOpen: false });
                  onOpenOnlineGuide();
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 0, alignItems: 'center', height: 45 }}>
                  <BookOpenIconCustom style={{ color: '#3f3f3f', width: 20, marginRight: 10 }} />
                  <h4 style={{ color: '#3f3f3f', margin: 0, marginTop: 0, fontSize: 16 }}><Entity entity="onlineManual" /></h4>
                </div>
              </ListItem>
              <ListItem
                key="help-1"
                button
                onClick={() => {
                  this.setState({ isOpen: false });
                  onOpenSupportTicket();
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'row', marginTop: 0, alignItems: 'center', height: 45 }}>
                  <MessageAlertIconCustom style={{ color: '#3f3f3f', width: 20, marginRight: 10 }} />
                  <h4 style={{ color: '#3f3f3f', margin: 0, marginTop: 0, fontSize: 16 }}><Entity entity="reportProblem" /></h4>
                </div>
              </ListItem>
            </List>
          </Card>
        </Popper>
      </div>
    );
  }
} 

export default HelpMenuDropdown;
